import React, { FC, useCallback, useContext, useMemo } from 'react';
import AnimatedCard from '../../../AnimatedCard';
import { isNolCardPayEventEnded } from '../../../nolCardPayEvent';
import styles from './index.module.scss';
import { getSVG } from '@/components/Common/styles/mixins';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';

const NolCardCashback: FC = () => {
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/v31/${path}`), []);
  const store = useContext(NolPromotionStoreCtx);

  const nolCouponCardProps = useMemo(() => {
    return {
      type: 'gray' as const,
      supTitle: <div className={styles.cardSupTitle}>이벤트 2</div>,
      title: (
        <div className={styles.cardTitle}>
          NOL 카드 페이로
          <br />
          모텔 결제 시
          <br />
          <span className={styles.blue}>2천원 즉시 할인</span>
        </div>
      ),
      image: (
        <img
          className={styles.nolCouponImage}
          src={
            isNolCardPayEventEnded()
              ? getResourcePath('v31_nol_card_pay_ended.png')
              : getSVG('/static/images/nol-promotion/v32/coupon0825.png')
          }
          alt={'NOL카드페이로 2천원 즉시 할인'}
        />
      ),

      descriptionTitle: (
        <div className={styles.descriptionTitle}>
          NOL 카드 페이에 등록된 NOL 카드로
          <br />
          NOL에서 모텔 상품 결제 시
        </div>
      ),
      descriptions: [
        {
          // text: <>이벤트 기간 : {store.eventPeriod}</>,
          text: <>이벤트 기간 : 2026년 8월 26일 (화) ~ 2026년 10월 19일 (월)</>,
          normal: true,
        },
        {
          text: (
            <>
              혜택 : 2천원 즉시 할인
              <br />: NOL 카드 페이로 NOL에서 모텔 상품 6만원 이상 결제 시 제공
            </>
          ),
          normal: true,
        },
        {
          text: <>NOL 카드 보유 회원 대상에 한해 1인당 1회 혜택 적용</>,
          normal: true,
        },
        {
          text: (
            <>
              본 이벤트는 기간 동 동안 NOL App/Web에서 모텔 상품
              <br /> 주문 결제 시 NOL 카드 페이를 결제 수단으로 선택하고
              <br /> 결제한 건에 한해 제공
              <br /> (* 일부 상품에 한하여 할인이 불가할 수 있습니다.)
            </>
          ),
          normal: true,
        },
        {
          text: <>이벤트 기간 내 결제 완료 건에 한하여 즉시 할인 혜택 제공</>,
          normal: true,
        },
        {
          text: <>혜택은 결제 단계에서 자동 적용되며, 최종 결제 전 할인 적용된 금액을 확인할 수 있음</>,
          normal: true,
        },
        {
          text: <>이벤트 유의사항 및 상세 내용은 [자세히 보기] 참고</>,
          bold: false,
          normal: true,
        },
      ],
      link: {
        onLinkClick: () => {
          location.href = 'https://content.yanolja.com/event/1894';
        },
        onLinkTitle: '자세히 보기',
      },
    };
  }, []);

  return (
    <AnimatedCard
      className={styles.nolCouponCardContainer}
      {...nolCouponCardProps}
      logData={{
        object: '자세히 보기',
        objectType: 'Btn',
        objectContainer: 'NOL에서 지금 받는 NOL 이벤트 혜택',
        motherPageVersion: store.version,
        motherPageSectionType: '혜택',
        motherPageSectionName: 'NOL카드 페이로 호텔 결제시 최대 3만원 즉시 할인',
        deepLinkUri: 'https://content.yanolja.com/event/1894',
      }}
    />
  );
};

export default observer(NolCardCashback);
